export default {"src":"/_next/static/media/tpad-logo-text.aa49ed4c.svg","height":593,"width":2251,"blurWidth":0,"blurHeight":0};